module.exports = __webpack_public_path__ + "static/media/sign_out_200px.587f7102.png";